import { render, staticRenderFns } from "./ContactViewSettings.vue?vue&type=template&id=7a0f581a&"
import script from "./ContactViewSettings.vue?vue&type=script&lang=js&"
export * from "./ContactViewSettings.vue?vue&type=script&lang=js&"
import style0 from "./ContactViewSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports